import {Possessed} from "../Possessed";
import {PossessedGameAssets} from "../PossessedGameAssets";
import {SpineGSAPWrapper } from "../animation/SpineGSAPWrapper";
import {PossessedSymbol, PossessedSymbolCreateArgs} from './PossessedSymbol';
import {gsap} from "gsap"

export class PossessedActivatorSymbol extends PossessedSymbol {
    
    private symbolSpine:PIXI.spine.Spine;
    private gemBurnSpine:PIXI.spine.Spine;

    private getGemBurnAnimation(crucifixReelLevel:number):string {
        const gemBurnAnims = ["gbD", "gbC", "gbB", "gbA"];
        return gemBurnAnims[crucifixReelLevel-1];
    }

    constructor(args:PossessedSymbolCreateArgs) {
        super(args);

        this.initDefaultSymbolSprites(args.initialState);

        this.symbolSpine = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.ACTIVATOR_SYM_SPINE));
        this.symbolSpine.visible = false;
        this.spriteView.addChild(this.symbolSpine);

        this.gemBurnSpine = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.ACTIVATOR_SYM_SPINE));
        if(Possessed.crucifixReel?.getCurrentLevel() < 5) {
            this.gemBurnSpine.state.setAnimation(0, this.getGemBurnAnimation(Possessed.crucifixReel.getCurrentLevel()), false);
        } else {
            this.gemBurnSpine.visible = false;
        }
        this.spriteView.addChild(this.gemBurnSpine);

        this.symbolSpine.position.y += 2;
        this.gemBurnSpine.position.y += 2;
    }

    public override getLandAnimation(): gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {SpineGSAPWrapper.resetSpineState(this.symbolSpine)})
            .add(SpineGSAPWrapper.createTimeline(this.symbolSpine, 0, "landing", 0))
            .add(() => {
                Possessed.soundPlayer.playSoundWithDavidPanning("xactLand", this.reelID);
            }, "<")
            .add(() => {
                Possessed.reelView.playBatsEffectCenter()
                Possessed.soundPlayer.playSound("xactBats");
            }, "<")
            .add(Possessed.reelView.playActivatorLand(this.reelID, this.reelPosition), "<")
            .add(()=>{
                this.symbolSpine.state.setAnimation(0, "active", true);
            })
    }

    public activate():gsap.core.Timeline {
        const tl = gsap.timeline();
        if(this.gemBurnSpine.visible == false) {
            tl.add(() => {
                SpineGSAPWrapper.resetSpineState(this.gemBurnSpine);
            })
        }
        tl.add(SpineGSAPWrapper.createTimeline(this.gemBurnSpine, 0, this.getGemBurnAnimation(Possessed.model.data.xCrucifixReel.length)))
        tl.add(SpineGSAPWrapper.createTimeline(this.symbolSpine, 0, "trigger"), "<");
        tl.add(() => {
            this.symbolSpine.visible = false;
        })
        return tl;
    }
}